/** True for an external OS-file drag ("Files" in the type list). */
export function hasExternalFiles(dataTransfer: DataTransfer | null | undefined): boolean {
  return Array.from(dataTransfer?.types ?? []).includes("Files");
}

/**
 * True when a drag event's target sits inside a modal. Dialogs portal to
 * document.body, but React routes synthetic events up the *React* tree, so a
 * dialog rendered by a descendant of a drop zone bubbles its drops back to that
 * zone even though the DOM says the two are unrelated. A drop released inside a
 * modal belongs to the modal, never to the surface behind it.
 */
export function isInsideModal(target: EventTarget | null): boolean {
  return (
    target instanceof Element && target.closest('[role="dialog"], [role="alertdialog"]') !== null
  );
}
